import React from 'react';
import { useNavigate } from 'react-router-dom';

const ReviewButton = ({ appointmentId, appointmentService }) => {
  const navigate = useNavigate();

  const handleReviewClick = () => {
    // Redirigir al usuario a la página de reseñas
    navigate(`/submit-review?appointmentId=${appointmentId}&service=${encodeURIComponent(appointmentService)}`);
  };

  return (
    <button 
      className="btn btn-primary btn-sm"
      onClick={handleReviewClick}
      style={{
        background: 'linear-gradient(135deg, #43e97b 0%, #38f9d7 100%)',
        border: 'none',
        color: 'white',
        display: 'flex',
        alignItems: 'center',
        gap: '0.5rem',
        padding: '0.5rem 0.75rem',
        borderRadius: '6px',
        fontSize: '0.875rem',
        fontWeight: '600',
        boxShadow: '0 2px 10px rgba(67, 233, 123, 0.3)',
        cursor: 'pointer',
        transition: 'all 0.2s ease'
      }}
      onMouseEnter={(e) => {
        e.target.style.transform = 'translateY(-2px)';
        e.target.style.boxShadow = '0 4px 15px rgba(67, 233, 123, 0.4)';
      }}
      onMouseLeave={(e) => {
        e.target.style.transform = 'translateY(0)';
        e.target.style.boxShadow = '0 2px 10px rgba(67, 233, 123, 0.3)';
      }}
    >
      <span>⭐</span>
      Dejar Reseña
    </button>
  );
};

export default ReviewButton;
